<template>
  <div class="d-flex justify-content-between w-100 mt-auto">
    <label
      class="d-flex justify-content-center align-items-center mb-0 text-center font-weight-bold"
    >
      {{ title }}
    </label>

    <div class="d-flex justify-content-center align-items-center">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'copy-text-title',
  props: {
    title: {
      type: String,
      default: '',
    },
  },
};
</script>
